/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isObject, objectHasPropertyString } from "utils/empty-exists";
import { LinkSelectorWrapper } from "cms/links/link-selector/link-selector-wrapper";
import { CustomAddLinkButton } from "./add-link-button";
// import { Logger } from "cms/utils/log/logger";

const SingleLinkSelector = (props) => {
    const linkGuid = props?.linkGuid; 
    const onChange = props?.onChange;
    const { token } = useAuth();
    const [link, setLink] = useState();
    const [loadingLink, setLoadingLink] = useState(false);

    const loadLink = async () => {
        if (linkGuid && linkGuid.length > 30) {
            const _link = await SimpliCityAdminSDK.link.findOne(token, linkGuid);
            setLink(_link);
            return _link;
        }
    };

    useEffect(() => {
        const load = async () => {
            if (linkGuid) {
                setLoadingLink(true);
                const _link = await loadLink(linkGuid);
                setLink(_link);
                setLoadingLink(false);
            }
        };
        // load once
        if (!isObject(link) || !objectHasPropertyString(link, "guid") || link?.guid !== linkGuid) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkGuid]);

    const onChangeLink = async (link) => {
        setLink(link);
        onChange(link?.guid || "");
    };
    
    const onRemoveLink = async () => {
        setLink(undefined);
        onChange("");
    };

    return (
        <div style={{ flex: "1", width: "100%" }}>
            <LinkSelectorWrapper
                link={link}
                setLink={setLink}
                linkGuid={linkGuid}
                setLinkGuid={() => {}} // Not needed for single link
                onLinkChange={(link) => onChangeLink(link)}
                onLinkRemove={() => onRemoveLink()}
                disabled={false}
                loadingLink={loadingLink}
                setLoadingLink={setLoadingLink}
                AddComponent={CustomAddLinkButton} // Use custom button instead of default
            />
        </div>
    );
};

export { SingleLinkSelector };
